import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Customer, CustomerOverviewModel, PaginationPage, PaginationResponse } from 'src/app/classes';
import { AbstractListWidgetInner, WidgetInnerView } from 'src/app/widget-inner';
import { FilterTypeCriteria, FilterTypes } from '../../../edit/edit-userfilter/edit-userfilter.component';
import * as globals from 'src/app/globals';
import { switchMap } from 'rxjs/operators';
import { CustomerService } from 'src/app/lib/customer/services/customer.service';
import { Observable, of } from 'rxjs';
import { showAnimation } from 'src/animations';
import { IWidgetProviderService, WIDGET_PROVIDER_SERVICE } from 'src/app/interfaces';

@Component({
  selector: 'app-customer-widget-inner',
  templateUrl: './customer-widget-inner.component.html',
  styleUrls: ['./customer-widget-inner.component.css'],
  animations: [ showAnimation ]
})
export class CustomerWidgetInnerComponent extends AbstractListWidgetInner<CustomerOverviewModel> {

  currentView;

  viewTitle: string = null;

  userFilterIdentifier: number = 0;

  constructor(
    @Inject(WIDGET_PROVIDER_SERVICE) private _widgetProviderService: IWidgetProviderService,
    private _router: Router,
    private _customerService: CustomerService
  ) {
    super();
    this.sortAttribute = "customername";
    this.currentFilterType = FilterTypes.find(x => x.value == "Customer");
    this.setInitialDefaultView();

    this.stringSearchProvider = (...args) => this._customerService.searchCustomersByString(...args);
    this.userFilterSearchProvider = (...args) => this._customerService.searchCustomersByUserFilter(...args);
  }

  addCustomer() {
    this._router.navigate(["/add-customer"]);
  }

  editCustomer(customer: Customer) {
    this._router.navigate(["/customer-details", customer.customerid]);
  }

  ngOnInit(): void {
    this._widgetProviderService.setWidgetInnerViews([
      {
        name: () => of('Neuen Kunden anlegen'),
        icon: () => of('add'),
        onClick: () => {
          this.addCustomer();
          return of(null);
        },
        color: () => of(globals.widgetAdderColor)
      } as WidgetInnerView
    ]);
  }
  
  setDefaultView(view) {

    this.currentView = view;
    if (view.title) this.viewTitle = view.title;
    if (view.sortAttribute) this.sortAttribute = view.sortAttribute;
    if (view.sortDsc) this.sortDsc = view.sortDsc;

    this.userFilterIdentifier = 0;

    this.updateContentProvider(this.page.asObservable().pipe(switchMap((page: PaginationPage) => {
      return view.provider(this._customerService, page) as Observable<PaginationResponse<CustomerOverviewModel[]>>;
    })));
  }

  setInitialDefaultView() {
    this.setDefaultView(CustomerWidgetDefaultViews[0]);
  }

  setFilter(criteria: FilterTypeCriteria<number>) {
    if (criteria.value == this.sortAttribute) this.sortDsc = !this.sortDsc;
    else {
      this.sortAttribute = criteria.value;
      this.sortDsc = false;
    }
    this.sortEntries();
  }

  CustomerWidgetDefaultViews = CustomerWidgetDefaultViews;

}

export const CustomerWidgetDefaultViews = [
  {
    title: "Zuletzt verwendet",
    icon: "history",
    provider: function (customerService: CustomerService, page: PaginationPage): Observable<PaginationResponse<CustomerOverviewModel[]>> {
      return customerService.getUserCustomerHistory(page);
    }
  }, {
    title: "Beobachtete Kunden",
    icon: "visibility",
    provider: function (customerService: CustomerService, page: PaginationPage): Observable<PaginationResponse<CustomerOverviewModel[]>> {
      return customerService.getUserCustomerFavourites(page);
    }
  }
];